/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

const Banner = ({ ...props }) => {

	const prop = props;

	const [Dataads, setDataads] = useState("");
	const [IsPLaceholder, setIsPLaceholder] = useState(true);

	const handleData = (e) => {

		setDataads(e);
		setIsPLaceholder(false);

	};

	useEffect(() => {

		let site = "mobile";
		if (!prop.is_mobile) {

			site = "desktop";

		}
		const urls = ["canary", "production"].includes(process.env.NEXT_PUBLIC_NODE_ENV)
			? "https://detikads.femaledaily.com/static/ads/femaledaily/"
			: "https://detikads.femaledaily.com/static/ads/femaledaily/staging_femaledaily/";
		fetch(`${urls + site}/${prop.name}.txt?${Math.random()}`)
			.then((response) => response.text())
			.then((data) => {

				const cleanData = data.trim();

				data !== "" || data !== " "	? handleData(cleanData)
					: null;

			});

	}, []);

	useEffect(() => {

		try {

			reviveAsync["0cceecb9cae9f51a31123c541910d59b"].refresh();

		} catch (e) {

			if (IsPLaceholder) {

				setIsPLaceholder(false);

			}

		}
		try {

			refreshSlotDfp(prop.name);

		} catch (e) {

			// console.log(e);

		}

	});

	return (
		<>
			{IsPLaceholder ? (
				<div id={prop.component_id || ""} className={prop.class_name || ""}>
					<img
						src={`https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/ads/${prop.placeholder}.png`}
						alt="banner-detik"
					/>
				</div>
			) : null}
			<div
				id={prop.component_id}
				className={prop.class_name || ""}
				dangerouslySetInnerHTML={{
					__html: Dataads,
				}}
			/>
			<style jsx>
				{`
          .bottomframe {
            bottom: -4px;
            left: 0px;
            position: fixed;
            right: 0px;
            text-align: center;
            z-index: 3;
          }
          .ads-billboard {
            padding: 20px 0;
          }
					.billboard-home {
						margin: 66px 0 0 0;
						text-align: center;
					}
					.horizontal-home {
						margin: ${Dataads ? "40px 0 0 0" : "0"};
					}
					.banner-1-mobile {
						text-align: center;
					}
					.mobile-staticbanner2 {
						margin-top: ${Dataads ? "16px" : "0"};
					}
        `}
			</style>
		</>
	);

};

export default Banner;
